import { Alert, useMediaQuery, useTheme } from '@mui/material'
import { CardCollapse } from 'src/pages/sistema/components'
import { useFirmas } from '../hooks/useFirmas';
import { FirmasConLabels } from '../types/firma';
import CircularProgress from '@mui/material/CircularProgress'
import { FirmasMobile } from './mobile/FirmasMobile';
import { FirmasDesktop } from './desktop/FirmasDesktop';
import {SistemaTipo} from "../../../types/enum/enum";

export const SeccionFirmas = ({ idOperacion, codSistema }: { idOperacion: number, codSistema: SistemaTipo }) => {

    const { firmas, refetch, status } = useFirmas(codSistema, idOperacion);

    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <CardCollapse title='Firmas' colapsable>
            {
                status === 'loading' && <CircularProgress disableShrink sx={{ mt: 6 }} />
            }
            {
                status === 'error' && <Alert severity='error'>Se produjo un error al cargar las firmas.</Alert>
            }
            {
                (status === 'success' && !firmas.firmas.length) &&
                <Alert severity='info'>No se encontraron firmas para esta operación.</Alert>
            }
            {
                (status === 'success' && !!firmas.firmas.length) && (
                    isSmallScreen ?
                        <FirmasMobile firmas={firmas} idOperacion={idOperacion} codSistema={codSistema} refetch={refetch} /> :
                        <FirmasDesktop firmas={firmas} idOperacion={idOperacion} codSistema={codSistema} refetch={refetch} />
                )
            }
        </CardCollapse>
    )
}

export type FirmasProps = {
    firmas: FirmasConLabels,
    idOperacion: number,
    codSistema: SistemaTipo,
    refetch: () => void
}
